const OnStoresIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.2"
        width="36.8348"
        height="37.0051"
        rx="18.4174"
        fill="#4A90E2"
      />
      <path
        d="M11.8333 13.6667V12H25.1667V13.6667H11.8333ZM11.8333 25.3333V20.3333H11V18.6667L11.8333 14.5H25.1667L26 18.6667V20.3333H25.1667V25.3333H23.5V20.3333H20.1667V25.3333H11.8333ZM13.5 23.6667H18.5V20.3333H13.5V23.6667ZM12.7083 18.6667H24.2917L23.7917 16.1667H13.2083L12.7083 18.6667Z"
        fill="#4A90E2"
      />
      <circle cx="20" cy="15" r="1.5" fill="#4A90E2" />
      <circle cx="23" cy="15" r="1.5" fill="#4A90E2" />
    </svg>
  );
};

export default OnStoresIcon;
